import {
  PlatformContextType,
  UserAccountType
} from "@wingspanhq/users/dist/lib/interfaces";
import { IS_LOCAL_ENV } from "../../shared/constants/environment";
import { selectorIsTaxOnlyPayeeContext } from "./selectors/selectorIsTaxOnlyPayeeContext";
import { selectorIsTaxOnlyPayerContext } from "./selectors/selectorIsTaxOnlyPayerContext";
import { DashboardFocusedFeatureContext } from "./useGetDashboardFocusedFeaturesContext";

export type CreateDashboardFocusedFeature = (
  context: DashboardFocusedFeatureContext
) => boolean;

export const DashboardFocusedFeaturesConfig = {
  // showTaxOnlyPayeeNavigation: (context: DashboardFocusedFeatureContext) => {
  //   return selectorIsTaxOnlyPayeeContext(context);
  // },
  showContractorDetailsTaxOnlyPayerEligibilityWarning: (
    context: DashboardFocusedFeatureContext
  ) => {
    return selectorIsTaxOnlyPayerContext(context);
  },
  showSideNavSwitchAccount: (context: DashboardFocusedFeatureContext) => {
    // isRequestingUserSessionExists ||  isAdminSessionExists || isRequestingUserTokenFromURL ? null : (

    return (
      !context.session.isAdminSessionExists &&
      !context.session.isRequestingUserSessionExists &&
      !context.session.isRequestingUserTokenFromURL
    );
  },
  showSideNavNew: (context: DashboardFocusedFeatureContext) => {
    return (
      !selectorIsTaxOnlyPayeeContext(context) &&
      !selectorIsTaxOnlyPayerContext(context)
    );
  },
  showSideNavGettingStarted: (context: DashboardFocusedFeatureContext) => {
    //         isVisible={!is1099OnlyRecipient}
    return true;
  },
  showSideNavGetPaid: (context: DashboardFocusedFeatureContext) => {
    //showGetPaidNav && !is1099OnlyRecipient && hasPaymentsScope
    return (
      context.hardcoded.showGetPaidNav &&
      !selectorIsTaxOnlyPayeeContext(context) &&
      context.access.hasPaymentsScope
    );
  },
  showSideNavSendPayments: (context: DashboardFocusedFeatureContext) => {
    // showSendPaymentsNav &&  !is1099OnlyRecipient && (hasPaymentsScope || hasCollaboratorsScope)
    return (
      context.hardcoded.showSendPaymentsNav &&
      !selectorIsTaxOnlyPayeeContext(context) &&
      (context.access.hasPaymentsScope || context.access.hasCollaboratorsScope)
    );
  },
  showSideNavPayables: (context: DashboardFocusedFeatureContext) => {
    //   hasPaymentsScope
    return context.access.hasPaymentsScope;
  },
  showSideNavPayees: (context: DashboardFocusedFeatureContext) => {
    // hasCollaboratorsScope
    return context.access.hasCollaboratorsScope;
  },
  showSideNavWorkLogsPayee: (context: DashboardFocusedFeatureContext) => {
    return context.user.payersWithWorkLoggingCount > 0;
  },
  showSideNavWorkLogsPayer: (context: DashboardFocusedFeatureContext) => {
    return context.user.workDefinitionsCount > 0;
  },
  showSideNavTaxFillingSection: (context: DashboardFocusedFeatureContext) => {
    const isUSUser = context.user.country === "US";

    //hasPaymentsScope && featureFlagsQuery.data?.nec1099FilingV2 && isEnterpriseUser
    const currentCondition =
      context.access.hasPaymentsScope &&
      context.experiments.nec1099season2024 &&
      (context.user.contexts.some(
        c =>
          c === PlatformContextType.TaxOnlyPayer ||
          c === PlatformContextType.Payer
      ) ||
        context.user.userType === UserAccountType.enterprise);

    // hasPaymentsScope &&
    //            featureFlagsQuery.data?.nec1099FilingV2 &&
    //            isEnterpriseUser

    const condition2023 =
      context.access.hasPaymentsScope &&
      context.user.userType === UserAccountType.enterprise;

    return isUSUser && (currentCondition || condition2023);
  },
  showSideNavFinancialBenefits: (context: DashboardFocusedFeatureContext) => {
    //!is1099OnlyRecipient && hasFinancesScope
    return (
      !selectorIsTaxOnlyPayeeContext(context) && context.access.hasFinancesScope
    );
  },
  showSideNavLifestyleBenefits: (context: DashboardFocusedFeatureContext) => {
    // TODO: only show this in local env
    if (IS_LOCAL_ENV) {
      return true;
    }

    //hasAdminScope && !isEnterpriseUser
    return (
      context.access.hasAdminScope &&
      context.user.userType !== UserAccountType.enterprise
    );
  },
  showSideNavReports: (context: DashboardFocusedFeatureContext) => {
    //!is1099OnlyRecipient && featureFlagsQuery.data?.reports && (hasPaymentsScope || hasCollaboratorsScope)

    return (
      !selectorIsTaxOnlyPayeeContext(context) &&
      context.experiments.reports &&
      (context.access.hasPaymentsScope || context.access.hasCollaboratorsScope)
    );
  },
  showSideNavDataAndIntegrations: (context: DashboardFocusedFeatureContext) => {
    // hasDocumentsScope || hasPaymentsScope
    return context.access.hasDocumentsScope || context.access.hasPaymentsScope;
  },
  showSideNavDocuments: (context: DashboardFocusedFeatureContext) => {
    //hasDocumentsScope
    return (
      context.access.hasDocumentsScope &&
      !context.experiments.masterPolicyEnrollment
    );
  },
  showSideNavMyResourcesSettings: (context: DashboardFocusedFeatureContext) => {
    return (
      context.experiments.masterPolicyEnrollment &&
      context.access.hasDocumentsScope
    );
  },
  showSideNavCustomFields: (context: DashboardFocusedFeatureContext) => {
    //hasAdminScope && showCustomFieldsNav
    return (
      context.access.hasAdminScope && context.hardcoded.showCustomFieldsNav
    );
  },
  showSideNavButchImports: (context: DashboardFocusedFeatureContext) => {
    //hasPaymentsScope && showBatchImportsNav
    return (
      context.access.hasPaymentsScope && context.hardcoded.showBatchImportsNav
    );
  },
  showSideNavIntegrations: (context: DashboardFocusedFeatureContext) => {
    //hasAdminScope && featureFlagsQuery.data?.qboOnboarding && isEnterpriseUser

    return (
      context.access.hasAdminScope &&
      context.experiments.qboOnboarding &&
      context.user.userType === UserAccountType.enterprise
    );
  },
  showSideNavTokens: (context: DashboardFocusedFeatureContext) => {
    //hasAdminScope
    return context.access.hasAdminScope;
  },
  showSideNavOrganizationAccounts: (
    context: DashboardFocusedFeatureContext
  ) => {
    //hasAdminScope && isEnterpriseUser
    return (
      context.access.hasAdminScope &&
      context.user.userType === UserAccountType.enterprise
    );
  },
  showSideNavSettings: (context: DashboardFocusedFeatureContext) => {
    //hasAdminScope || hasPaymentsScope
    return context.access.hasAdminScope || context.access.hasPaymentsScope;
  },
  showSideNavAccountSettings: (context: DashboardFocusedFeatureContext) => {
    //hasAdminScope
    return context.access.hasAdminScope;
  },
  // TODO: this looks strange
  showSideNavPayoutMethodSettings: (
    context: DashboardFocusedFeatureContext
  ) => {
    //hasPaymentsScope && showPayoutNav
    return context.access.hasPaymentsScope && context.hardcoded.showPayoutNav;
  },
  // TODO: this looks strange
  showSideNavPaymentMethodSettings: (
    context: DashboardFocusedFeatureContext
  ) => {
    //hasPaymentsScope && showPayoutNav
    return context.access.hasPaymentsScope && context.hardcoded.showPaymentNav;
  },
  // TODO: this looks strange
  showSideNavPayoutAndPaymentsMethodSettings: (
    context: DashboardFocusedFeatureContext
  ) => {
    //hasPaymentsScope && !showPayoutNav && !showPaymentNav
    return (
      context.access.hasPaymentsScope &&
      !context.hardcoded.showPayoutNav &&
      !context.hardcoded.showPaymentNav
    );
  },
  showSideNavSendPaymentsSettings: (
    context: DashboardFocusedFeatureContext
  ) => {
    //(hasPaymentsScope || hasAdminScope) &&
    //               showPayeableAndPayrollSettingsNav &&

    return (
      (context.access.hasPaymentsScope || context.access.hasAdminScope) &&
      context.hardcoded.showPayableAndPayrollSettingsNav
    );
  },
  showSideNavEngagementRequirements: (
    context: DashboardFocusedFeatureContext
  ) => {
    //   hasAdminScope && isEngagementsActive

    return (
      (context.access.hasAdminScope || context.access.hasCollaboratorsScope) &&
      !!context.user.labels?.engagements
    );
  },
  showSideNavTaxProfileSettings: (context: DashboardFocusedFeatureContext) => {
    //   hasAdminScope
    return context.access.hasAdminScope;
  },
  showSideNavTaxDocumentsSettings: (
    context: DashboardFocusedFeatureContext
  ) => {
    // hasAdminScope

    return context.access.hasAdminScope;
    // context.access.hasAdminScope &&
    // context.experiments.nec1099season2024 &&
    // context.user.contexts.some(
    //   c =>
    //     c === PlatformContextType.TaxOnlyPayee ||
    //     c === PlatformContextType.Payee
    // )
  },
  showSideNavNotificationsSettings: (
    context: DashboardFocusedFeatureContext
  ) => {
    // hasAdminScope
    return context.access.hasAdminScope;
  },
  showSideNavTeamsSettings: (context: DashboardFocusedFeatureContext) => {
    // hasAdminScope
    return context.access.hasAdminScope;
  },
  showSideNavEmailSettings: (context: DashboardFocusedFeatureContext) => {
    //hasAdminScope && hasEmailSnippets
    return (
      context.access.hasAdminScope &&
      Object.keys(context.customization.emailCustomization?.templates ?? {})
        .length > 0
    );
  },
  showTaxFilingYearSwitcher: (context: DashboardFocusedFeatureContext) => {
    // hasPaymentsScope &&
    //            featureFlagsQuery.data?.nec1099FilingV2 &&
    //            isEnterpriseUser

    return (
      context.access.hasPaymentsScope &&
      context.user.userType === UserAccountType.enterprise
    );
  },
  showAxisBenefits: (context: DashboardFocusedFeatureContext) => {
    return context.experiments.customBenefitsLloydCapital;
  },
  showBenefits: (context: DashboardFocusedFeatureContext) => {
    if (
      context.experiments.customBenefitsLloydCapital &&
      context.user.payersCount < 2
    ) {
      return false;
    }

    return true;
  }
} satisfies Record<string, CreateDashboardFocusedFeature>;

export type DashboardFocusedFeatureKey =
  keyof typeof DashboardFocusedFeaturesConfig;
